import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslationPipe } from '../../pipes';

@Component({
  standalone: true,
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  imports: [TranslationPipe],
  styleUrl: './search-input.component.scss',
})
export class SearchInputComponent {
  @Input() inputData = '';
  @Input() placeholder = '';

  @Output() search = new EventEmitter<string>();

  onInputChange(event: Event) {
    this.inputData = (event.target as HTMLInputElement).value;
    this.search.emit(this.inputData);
  }

  performSearch() {
    if (this.inputData?.length > 0) {
      this.search.emit(this.inputData);
    }
  }
}
